import { Component, Input, OnInit, AfterViewChecked, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-matrix-answer',
  templateUrl: './matrix-answer.component.pug',
  styleUrls: ['./matrix-answer.component.scss'],
  standalone: false
})
export class MatrixAnswerComponent implements AfterViewChecked, OnInit {
  @Input() options: any;
  @Output() disableSave:EventEmitter<any> = new EventEmitter();
  constructor() { }

  ngOnInit(): void {
  }
  ngAfterViewChecked(){
    for (let i = 0; i < this.options.options.length; i++) {
      const option = this.options.options[i];
      if (!option.text) {
        this.disableSave.emit(true);
        return
      }
    }
    for (let j = 0; j < this.options.categories.length; j++) {
      const category = this.options.categories[j];
      if (!category.text) {
        this.disableSave.emit(true);
        return
      }
      for (let rowIndex = 0; rowIndex < category.rows.length; rowIndex++) {
        const row = category.rows[rowIndex];
        if (!row.text) {
          this.disableSave.emit(true);
          return
        }
      }
    }
    this.disableSave.emit(false);
  }
  addOption(index){
    let option = {
      'placeholder': $localize`Enter an option`,
      'text': '',
      'comments_required': true
    };
    this.options.options.splice(index+1, 0, option);
  }

  removeOption(index){
    if(this.options.options.length<=2){
      return;
    }
    this.options.options.splice(index, 1);
  }

  addCategory(){
    let category = {
      'placeholder': $localize`Enter a section title`,
      'text': '',
      'rows': [
        {
            'placeholder': $localize`Add a row item`,
            'text': '',
        }
      ]
    };
    this.options.categories.push(category);
  }

  removeCategory(index){
    this.options.categories.splice(index, 1);
  }

  addSubCategory(index, subindex){
    let row = {
      'placeholder': $localize`Add a row item`,
      'text': '',
    };
    this.options.categories[index].rows.splice(subindex+1, 0 , row)
  }

  removeSubCategory(index, subindex){
    this.options.categories[index].rows.splice(subindex, 1);
  }
}
